import produce from 'immer';
import { IFeed, IFeedState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { IFeedAction } from '../actions/feedActions';
export const initialFeedState: IFeedState = {
  feedIds: [],
  feedMap: {},
  isFetching: false
};
const feedReducer = (
  state = initialFeedState,
  action: IFeedAction
): IFeedState => {
  const feedIds: string[] = [];
  const feedMap: { [key: string]: IFeed } = {}; // feed code to feed json map

  return produce(state, (draft: IFeedState) => {
    switch (action.type) {
      case actionTypes.FETCH_FEEDS_SUCCESS:
        draft.isFetching = false;
        action.payload.map((feed: any) => {
          feedIds.push(`${feed.code}#${feed.customer}`);
          feedMap[`${feed.code}#${feed.customer}`] = feed;
        });
        draft.feedIds = feedIds;
        draft.feedMap = feedMap;
        break;
    }
  });
};

export default feedReducer;
